import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex align-items-center justify-content-start m-2" }
const _hoisted_2 = { class: "app-label-small font-bold text-gray-l1" }
const _hoisted_3 = {
  key: 0,
  class: "p-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppSubMenuLink = _resolveComponent("AppSubMenuLink")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item, i) => {
    return (_openBlock(), _createElementBlock("div", {
      key: item.label || i
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(item.label), 1)
      ]),
      (item.items)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_AppSubMenuLink, {
              items: item.items,
              onClickedLink: _ctx.onItemClicked
            }, null, 8, ["items", "onClickedLink"])
          ]))
        : _createCommentVNode("", true)
    ]))
  }), 128))
}